import styled from 'styled-components';

export const FlexCenterHV = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${(props) => props.padding};
  column-gap: ${(props) => props.gap};
`;

export const FlexCenterV = styled(FlexCenterHV)`
  justify-content: flex-start;
`;
export const FlexCenterVHE = styled(FlexCenterHV)`
  justify-content: flex-end;
`;

export const FlexCenterH = styled(FlexCenterHV)`
  align-items: flex-start;
`;

export const FlexCenterVSpaceBH = styled(FlexCenterHV)`
  justify-content: space-between;
`;

export const CartHeaderContainer = styled(FlexCenterVSpaceBH)`
  padding: 14px 0 18px;
  border-bottom: 1px solid #7070709e;
  height: 57px;
  position: absolute;
  z-index: 999;
  width: 100%;
  max-width: 420px;
  background: #fff;
  top: 0;
  padding: 0 14px;
  right: 0;

  img {
    margin-right: 10px;
  }
`;

export const CartTitle = styled.h4`
  color: hsl(0deg, 0%, 0%, 80%);
`;

export const TotalItems = styled.div`
  color: hsl(0deg, 0%, 0%, 80%);
`;
